import Ajax from '@utils/ajax';

export default {
  fetch(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/bookmarks`,
      ...options,
    });
  },

  create(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/bookmarks`,
      data: data,
      ...options,
    });
  },

  undo(group, rec) {
    return Ajax.post({
      url: `/groups/${group.id}/bookmarks/${rec.id}/undo`,
    });
  },

  sendEmail: function (group, recObject, email, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/bookmarks/send_email`,
      data: {
        email: email,
        rec_object_id: recObject && recObject.id,
      },
      ...options,
    });
  },

  update(group, rec, section, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/bookmarks/${rec.id}`,
      data: {
        new_section_id: section && section.id,
        new_group_id: group.id,
        _method: 'PATCH',
      },
      ...options,
    });
  },

  changeSection(group, rec, section, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/bookmarks/${rec.id}/change_section`,
      data: {
        new_section_id: section && section.id,
        _method: 'PATCH',
      },
      ...options,
    });
  },
};
